import { GraphQLClient } from 'graphql-request'
//import { RequestDocument, Variables } from 'graphql-request/dist/types'

export const DEFAULT_ENDPOINT_URL = process.env.REACT_APP_API_URL || ''
export const gqlClient = new GraphQLClient(DEFAULT_ENDPOINT_URL, { fetch: fetch })
export const useGqlClient = () => {
  return gqlClient
}